import makeHttpRequest from '../helpers/ajax';

const getOemAPIURL = () => {
    return WP_OEM_APIURL;
};

const requestData = (url, storageKey) => {
    const request = {
        url,
        expTime: 15 * 60 * 1000,
        storageKey,
        headers: {
            'x-requested-with': 'XMLHttpRequest',
        },
    };
    return request;
};

const makeRequest = request => makeHttpRequest(request).then(response => JSON.parse(response), (error) => {
    console.warn(`There is some issue with network call, please try again ${error}`);
});

const getYearList = (carType) => {
    const url = `${getOemAPIURL()}GetYears/${carType}`;
    const storageKey = `Years_${carType}`;
    const request = requestData(url, storageKey);
    return makeHttpRequest(request).then(response => JSON.parse(response).sort(), (error) => {
        console.warn(`There is some issue with network call, please try again${error}`);
    });
};

const getMakeList = (carType, year) => {
    const url = `${getOemAPIURL()}GetMakes/${carType}/${year}`;
    const storageKey = `Makes_${carType}_${year}`;
    const request = requestData(url, storageKey);
    return makeRequest(request);
};

const getModelList = (carType, year, make) => {
    const url = `${getOemAPIURL()}GetModels/${make}/${carType}/${year}`;
    const storageKey = `Models_${year}_${make}`;
    const request = requestData(url, storageKey);
    return makeRequest(request);
};

const getTrimList = (modelId) => {
    const url = `${getOemAPIURL()}GetTrims/${modelId}`;
    const storageKey = `Trims_${modelId}`;
    const request = requestData(url, storageKey);
    return makeRequest(request);
};

const getMarketValues = (trimId, mileage, zipcode) => {
    let result = '';
    if (trimId && mileage && zipcode) {
        const url = `${getOemAPIURL()}GetMarketValues/${trimId}/${zipcode}?mileage=${mileage}`;
        const storageKey = `Price_${trimId}_${mileage}_${zipcode}`;
        const request = requestData(url, storageKey);
        result = makeRequest(request);
    }
    return result;
};

export {
    getYearList,
    getMakeList,
    getModelList,
    getTrimList,
    getMarketValues,
};
